// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/registerServiceWorker';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import VueFire from 'vuefire'
import Firebase from 'firebase'
import VueRouter from 'vue-router'
import route from './router'
import _ from 'lodash'
// import { orderby } from 'lodash'
// import orderBy from 'lodash.orderby'
import Clipboard from 'v-clipboard'
import SlinkPlugins from './components/plugins.js'
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import App from './App'
import router from './router'
// import linkinfo from './components/linkinfo_component'
// import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
// import vCardsJS from 'vcards-js'
// import draggable from 'vuedraggable'
import FontPicker from 'font-picker-vue';

import './registerServiceWorker'




Vue.config.productionTip = false
Vue.use(VueMaterial)
Vue.use(VueFire)
Vue.use(router)
Vue.use(VueRouter)
Vue.use(Clipboard)
Vue.use(SlinkPlugins)
// Vue.use(linkinfo)
Vue.use(vueNumeralFilterInstaller);
Vue.use(FontPicker);

Vue.use(VueAnalytics, {
  // id: ['UA-81938309-3'],
  id: ['UA-81938309-3'],beforeFirstHit () {
    // this is right after the tracker and before every other hit to Google Analytics
    // console.log('ga beforefirsthit -main')
  },
  ready () {
    // console.log('ga ready -main')
    // here Google Analytics is ready to track!
  },
  // checkDuplicatedScript: true,
  router
})



let app;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  mounted(){
    this.$material.inkRipple = false;
    // this.checkInAppBrowser();
  },
  // methods: {
  //   checkInAppBrowser() {
  //     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  //     // Detect in-app browsers (basic detection)
  //     console.log('userAgent', userAgent)
  //     if (/FBAN|FBAV|Instagram/.test(userAgent)) {
  //       alert('For the best experience, please open this page in your browser');
  //       // Optionally, try to force opening in a new tab
  //       window.open(window.location.href, '_blank');
  //     }
  //   }
  // }
})


// WEBPACK FOOTER //
// ./src/main.js